import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SplitPaymentsService } from "app/split-payments/split-payments.service";

import { ButtonSharedModule, ModalSharedModule } from "pf_styleguide";

import { DiscontinuedSportService } from "../discontinued-sport/discontinued-sport.service";
import { PartnerBannerModule } from "../partner/partials/banner/partner-banner.module";
import { SportFormatSurfaceTextPipe } from "../pipe/sport-format-surface-text.pipe";
import { SportToPitchCourtTextPipe } from "../pipe/sport-to-pitch-court-text.pipe";
import { ApiEndpoints } from "../shared/apiEndpoints";
import { DateService } from "../shared/date.service";
import { EnquiryService } from "../shared/enquiry.service";
import { EventTrackingService } from "../shared/eventTracking.service";
import { LinkService } from "../shared/link.service";
import { MlpHelper } from "../shared/mlpHelper";
import { UserService } from "../shared/user.service";
import { ContactDetailsService } from "./../shared/module/contact-details/contact.details.service";
import { VenueContentModule } from "./content/venue-content.module";
import { PitchResolver } from "./pitch-resolver";
import { NotFoundModule } from "../shared/module/not-found/not-found.module";
import { VenueSidebarModule } from "./sidebar/venue-sidebar.module";
import { VenuePipeModule } from "./venue-pipe.module";
import { VenueResolver } from "./venue-resolver";
import { VenueComponent } from "./venue.component";
import { VenueService } from "./venue.service";
import { ViewportService } from "./viewport.service";

@NgModule({
    declarations: [VenueComponent],
    imports: [
        CommonModule,
        PartnerBannerModule,
        VenueContentModule,
        VenueSidebarModule,
        VenuePipeModule,
        RouterModule.forChild([
            {
                path: "",
                pathMatch: "full",
                component: VenueComponent,
                resolve: {
                    general: VenueResolver,
                },
            },
            {
                path: ":sportFormatPitchId",
                pathMatch: "full",
                component: VenueComponent,
                resolve: {
                    general: PitchResolver,
                },
            },
            {
                path: ":sportFormatPitchId/enquiry/thank-you",
                loadChildren:
                    "./enquiry-thank-you/enquiry-thank-you.module#EnquiryThankYouModule",
            },
        ]),
        ButtonSharedModule,
        ModalSharedModule,
        NotFoundModule,
    ],
    exports: [],
    providers: [
        VenueService,
        DateService,
        DatePipe,
        MlpHelper,
        ApiEndpoints,
        SportToPitchCourtTextPipe,
        SportFormatSurfaceTextPipe,
        EnquiryService,
        EventTrackingService,
        LinkService,
        ContactDetailsService,
        DiscontinuedSportService,
        PitchResolver,
        VenueResolver,
        UserService,
        ViewportService,
        SplitPaymentsService
    ],
})
export class VenueModule {}
